// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-vvBzPc{z-index:101;background-color:#fff;flex-shrink:0;justify-content:flex-end;width:400px;height:100%;display:flex}.container-vvBzPc .debug-panel-lazy-loading-mv6FhJ{justify-content:center;align-items:center;width:100%;height:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container-vvBzPc`,
	"debug-panel-lazy-loading": `debug-panel-lazy-loading-mv6FhJ`,
	"debugPanelLazyLoading": `debug-panel-lazy-loading-mv6FhJ`
};
export default ___CSS_LOADER_EXPORT___;
